module.exports = __webpack_public_path__ + "Lato-Heavy.b0357e425384d4222769.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Heavy.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Heavy.eot
// module chunks = styles